// Import component scripts (auto-generated)
import './components.js';

// Import layout scripts (auto-generated)
import './layouts.js';

// Import theme scripts
import './core.js';
import './brndpwr-header.js';
import './brndpwr-footer.js';
import './brndpwr-site.js';
import './brndpwr-blocks.js';
import './faq.js';
import './lazy-load-images.js';
